import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { ProductService } from '../service/ProductService';
import { EventService } from '../service/EventService';
import { SplitButton } from 'primereact/splitbutton';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useAuth } from '../context/AuthContext';




const toolbarItems = [
    {
        label: 'Save',
        icon: 'pi pi-check'
    },
    {
        label: 'Update',
        icon: 'pi pi-upload'
    },
    {
        label: 'Delete',
        icon: 'pi pi-trash'
    },
    {
        label: 'Home Page',
        icon: 'pi pi-home'
    },
];

const toolbarLeftTemplate = () => {
    return (
        <>
            <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} />
            <Button label="Open" icon="pi pi-folder-open" className="p-button-secondary" />

            <i className="pi pi-bars p-toolbar-separator" style={{ marginRight: '.5em' }}></i>

            <Button icon="pi pi-check" className="p-button-success" style={{ marginRight: '.5em' }} />
            <Button icon="pi pi-trash" className="p-button-warning" style={{ marginRight: '.5em' }} />
            <Button icon="pi pi-print" className="p-button-danger" />
        </>
    )
};
const toolbarRightTemplate = <SplitButton label="Options" icon="pi pi-check" model={toolbarItems} menuStyle={{ width: '12rem' }}></SplitButton>;
const cardHeader = (
    <div className="p-card-title">
        <h5>Card</h5>
        <Button icon="pi pi-plus" className="p-button-text" />
    </div>
);

export const Dashboard = () => {

    const [tasksCheckbox, setTasksCheckbox] = useState([]);
    const [dropdownCity, setDropdownCity] = useState(null);
    const [events, setEvents] = useState(null);
    const [products, setProducts] = useState(null);



    useEffect(() => {
        const productService = new ProductService();
        const eventService = new EventService();
        productService.getProductsSmall().then(data => setProducts(data));
        eventService.getEvents().then(data => setEvents(data));
    }, []);

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const onTaskCheckboxChange = (e) => {
        let selectedTasks = [...tasksCheckbox];
        if (e.checked)
            selectedTasks.push(e.value);
        else
            selectedTasks.splice(selectedTasks.indexOf(e.value), 1);

        setTasksCheckbox(selectedTasks);
    };

    return (
        

        <div className="p-grid p-fluid dashboard">
            {/* {console.log(myUser.name)} */}
            <div className="p-col-12 p-lg-4 ">
                <div className="card summary p-shadow-1">
                    <span className="title">Usuarios</span>
                    <span className="detail">Total de usuarios</span>
                    <span className="count visitors p-shadow-1">165</span>
                    {/* <span className="count visitors p-shadow-1">{(myUser.name === '' ? 'Sin Ususario'  : myUser.name )  }</span> */}
                </div>
            </div>
            <div className="p-col-12 p-lg-4">
                <div className="card summary p-shadow-1">
                    <span className="title">Recibos</span>
                    <span className="detail">Sin Firmar</span>
                    <span className="count purchases p-shadow-1">0</span>
                </div>
            </div>
            <div className="p-col-12 p-lg-4">
                <div className="card summary p-shadow-1">
                    <span className="title">Vacaciones</span>
                    <span className="detail">Vacaciones Pendientes</span>
                    <span className="count revenue p-shadow-1">0</span>
                </div>
            </div>


            <div className="p-col-12 ">
                <div className="card p-shadow-1">
                    <h5>Notificaciones</h5>
                    <Accordion activeIndex={0}>
                        <AccordionTab header="Nueva plataforma de gestión en línea - (Recibos de sueldo) - 2021/10/13">
                            <p>Hemos desarrollado una nueva plataforma para facilitarte el acceso a tu información en linea.
                                <br/>
                               <br/>
                               La misma se irá actualizando con mas y mejores funcionalidades para agilizar los tiempos y procesos de comunicación.
                               <br/>
                               <br/>
                               El primer módulo que hemos incorporado es el de gestión de tus recibos de sueldo digitales.<br/>
                               Podés disponer de los mismos a partir de agosto del 2020 (2020-08), mes en el cual, debido a la pandemia, se comenzó la publicación en dicho formato.
                              
                               <br/>
                               <br/>
                               Confiamos en que la incorporación de esta herramienta en línea te permitirá autogestionar tu información de manera ágil .
                               <br/>
                               <br/>
                               Si tenés alguna sugerencia sobre la misma esperamos nos la hagas llegar a través Gestión de Personas.
                               <br/>
                               <br/>
                               Desde ya muchas gracias!
                               <br/>
                               <br/>
                            </p>
                        </AccordionTab>
                        <AccordionTab header="Modificaciones de layout de Planta - 2021/10/12">
                            <p>Debido a la incorporación de los nuevos equipos de producción, en planta se están realizando cambios en la disposición de algunos elementos.
                               <br/>
                               <br/>
                                Uno de ellos es el Box de extrusión y Centro de impresiones de rótulos de pallet.
                               <br/>
                               El mismo será desplazado hacia el sector de extrusión.
                               <br/>
                               <br/>
                               Temporalmente el centro de impresión continuará en dicho box de extrusión. 
                               <br/>
                               Pero en breve y para facilitar tu acceso a las impresiones procederemos a descentralizar dichas impresoras, configurando varios centros de impresión sectorizados.
                               <br/>
                               <br/>
                               Te mantendremos informado a medida que avancemos con dichos cambios.
                               <br/>
                               <br/>
                                 </p>
                        </AccordionTab>
                    </Accordion>
                </div>
            </div>
    </div>

    );
}
